export default "__VITE_ASSET__B3Hhm90f__"